module.exports = __webpack_public_path__ + "photo-collage-mobile.png";


//////////////////
// WEBPACK FOOTER
// ./theme/bananar/assets/HighSchoolOpenHouse2024/photo-collage-mobile.png
// module id = 217
// module chunks = 0 1